import { Navigate, Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import { ReportsLayout } from 'src/features/statistics/components/ReportsLayout';
import { StatisticsLayout } from 'src/features/statistics/components/StatisticsLayout';
import CashCollections from 'src/features/statistics/routes/CashCollections';
import OccupancyDuration from 'src/features/statistics/routes/OccupancyDuration';
import OccupancyTimeframe from 'src/features/statistics/routes/OccupancyTimeframe';
import OperationGuests from 'src/features/statistics/routes/OperationGuests';
import OperationManualPointOpens from 'src/features/statistics/routes/OperationManualPointOpens';
import OperationValidations from 'src/features/statistics/routes/OperationValidations';
import ParkingVisits from 'src/features/statistics/routes/ParkingVisits';
import Payments from 'src/features/statistics/routes/Payments';
import Reports from 'src/features/statistics/routes/Reports';
import useHasPermissions from 'src/hooks/useHasPermissions';

const StatisticsRoutes = () => {
    const permissionStats = useHasPermissions([PERMISSION.STATS]);
    const permissionVisits = useHasPermissions([PERMISSION.STATS_VISITS]);
    const permissionDurations = useHasPermissions([PERMISSION.STATS_DURATIONS]);
    const permissionTimeframe = useHasPermissions([PERMISSION.STATS_TIMEFRAME]);
    const permissionPayments = useHasPermissions([PERMISSION.STATS_PAYMENTS]);
    const permissionValidations = useHasPermissions([PERMISSION.STATS_VALIDATIONS]);
    const permissionGuestActions = useHasPermissions([PERMISSION.STATS_GUEST_ACTIONS]);
    const permissionManualActions = useHasPermissions([PERMISSION.STATS_MANUAL_ACTIONS]);
    const permissionStatsCashCollections = useHasPermissions([PERMISSION.STATS_CASH_COLLECTIONS]);

    return permissionStats ? (
        <Routes>
            <Route path="" element={<StatisticsLayout />}>
                <Route path="" element={<Navigate to="/statistics/reports" />} />
                <Route path="reports" element={<Reports />} />
                <Route path="*" element={<Navigate to="/statistics/reports" />} />
            </Route>
            <Route path="reports" element={<ReportsLayout />}>
                {permissionVisits && <Route path="parking-visits" element={<ParkingVisits />} />}
                {permissionDurations && <Route path="occupancy-duration" element={<OccupancyDuration />} />}
                {permissionTimeframe && <Route path="occupancy-timeframe" element={<OccupancyTimeframe />} />}
                {permissionPayments && <Route path="payments" element={<Payments />} />}
                {permissionValidations && <Route path="operation-validations" element={<OperationValidations />} />}
                {permissionGuestActions && <Route path="operation-guests" element={<OperationGuests />} />}
                {permissionStatsCashCollections && <Route path="cash-collections" element={<CashCollections />} />}
                {permissionManualActions && (
                    <Route path="operation-manual-point-opens" element={<OperationManualPointOpens />} />
                )}
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
        </Routes>
    ) : (
        <Navigate to=".." />
    );
};

export default StatisticsRoutes;
